module.exports = "/packs/visa-0aa74ec9faf2b1b3c18a1f324c567065.png";